module.exports = __webpack_public_path__ + "static/victoria-memorial-penny-farthing-69ff6df780b251ac5a7350a786a1f6b1.jpg";